module.exports = __webpack_public_path__ + "img/sl_banner2.9183fe37.png";